<template>
  <!-- Card 86akj8ptp (retorno de 23/09): a comunicação da escola chega com
       imagem e botão, e não com o link colado no fim do texto. `part` põe a
       imagem acima do texto e o botão abaixo, como na prévia do admin. -->
  <div class="ncomm">
    <div v-if="part === 'media' && communication.pinned" class="ncomm__pin">
      {{ $t("notifications.pinned") }}
    </div>

    <img
      v-if="part === 'media' && communication.image && !imageFailed"
      :src="communication.image"
      alt=""
      class="ncomm__image"
      loading="lazy"
      @error="imageFailed = true"
    />

    <a
      v-if="part === 'action' && communication.ctaLink"
      :href="communication.ctaLink"
      :target="isInternal ? null : '_blank'"
      :rel="isInternal ? null : 'noopener noreferrer'"
      class="ncomm__cta"
      :style="{ background: color }"
      @click="open"
    >
      {{ communication.ctaLabel || $t("notifications.learnMore") }}
      <v-icon v-if="!isInternal" size="16" color="white"
        >mdi-open-in-new</v-icon
      >
    </a>
  </div>
</template>

<script>
import pitchCustomerApi from "@/shared/pitchCustomerApi";
import pitchPartnerApi from "@/shared/pitchPartnerApi";

export default {
  name: "CommunicationContent",

  props: {
    notificationId: { type: String, required: true },
    // { image, ctaLabel, ctaLink, pinned } -- vem da API junto da notificação.
    communication: { type: Object, required: true },
    color: { type: String, default: "#A826E1" },
    part: {
      type: String,
      default: "action",
      validator: (value) => ["media", "action"].includes(value),
    },
  },

  data() {
    return { imageFailed: false };
  },

  computed: {
    // "/connect/aluno/..." é uma página do próprio Connect: navega pelo
    // router, sem abrir aba nova.
    isInternal() {
      return String(this.communication.ctaLink || "").startsWith("/");
    },
  },

  watch: {
    "communication.image"() {
      this.imageFailed = false;
    },
  },

  methods: {
    open(event) {
      // O clique conta mesmo se a navegação falhar; e a falha em registrar o
      // clique nunca pode impedir o aluno de seguir o link.
      // Aluno e professor recebem comunicacao (fase 3); a caixa de entrada e
      // compartilhada, entao a chamada escolhe a area pela rota (o `module`
      // do store usa valores diferentes em telas diferentes).
      const path = String(this.$route?.path || "");
      const clickApi = path.startsWith("/connect/aluno")
        ? pitchCustomerApi
        : path.startsWith("/connect/professor")
        ? pitchPartnerApi
        : null;
      if (clickApi) {
        clickApi.clickNotification(this.notificationId).catch(() => null);
      }

      if (!this.isInternal) return;

      event.preventDefault();
      if (this.$route?.fullPath !== this.communication.ctaLink) {
        this.$router.push(this.communication.ctaLink).catch(() => null);
      }
    },
  },
};
</script>

<style scoped>
.ncomm {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: 4px;
}

.ncomm__pin {
  align-self: flex-start;
  padding: 3px 10px;
  border-radius: 999px;
  background: rgba(168, 38, 225, 0.1);
  color: var(--dk-grape, #9923cd);
  font-size: 0.75rem;
  font-weight: 700;
}

.ncomm__image {
  display: block;
  width: 100%;
  max-height: 320px;
  object-fit: cover;
  border-radius: 12px;
}

.ncomm__cta {
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 22px;
  border-radius: 999px;
  color: #fff !important;
  font-weight: 700;
  font-size: 0.9rem;
  text-decoration: none;
}

.ncomm__cta:hover {
  filter: brightness(1.08);
}
</style>
